export default __webpack_public_path__ + "static/media/happy_to_help_slide_1.2f05b8d6.png";